import React from "react"
import { Box, Progress, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"

export const MerchantDeclineLoading = () => (
  <div>
    <Box sx={{ textAlign: "center", paddingBlockStart: "4rem" }}>
      <Typography variant="h3">
        <FormattedMessage defaultMessage="Still loading, just a moment…" />
      </Typography>
    </Box>

    <Box display="flex" justifyContent="center" alignItems="center" sx={{ blockSize: "100%" }}>
      <Progress />
    </Box>
  </div>
)
